import Chip from '@mui/material/Chip';

export { Chip };
